export default __webpack_public_path__ + "img/play.91453c84.svg";